export const STATES = {
  QUEUED: "QUEUED",
  RECEIVED: "RECEIVED",
  STARTED: "STARTED",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  REJECTED: "REJECTED",
  REVOKED: "REVOKED",
  RETRY: "RETRY",
  RECOVERED: "RECOVERED",
  CRITICAL: "CRITICAL",
};

export const STATES_COLORS = {
  QUEUED: "#f6f162",
  RECEIVED: "#42A5F6",
  STARTED: "#536DFE",
  SUCCEEDED: "#00FFFF",
  FAILED: "#FF00FF",
  REJECTED: "#007B9E",
  REVOKED: "#7266BA",
  RETRY: "#F9A826",
  RECOVERED: "#00BFA6",
  CRITICAL: "#F50057",
};
